import { default as Alert } from './Alert';

export default Alert;
